//imports
import { json2excel } from 'js2excel';
import { batchActions } from "redux-batched-actions";
import { displayErrorMessage, sendMessage, exportcsv } from '@insticator/insticator-ui';
import { loadingEmails, downloadingEmails } from 'state/actions/emailCollectionState/selected_embed_email_status';
//utils
import { getEmbedEmailData } from 'utils/api/embed';
//export action types
export const RECEIVE_EMAIL_DATA = 'RECEIVE_EMAIL_DATA';


//actions
export const receiveEmailData = emailData => ({
    type: RECEIVE_EMAIL_DATA,
    emailData
});

//batched actions

const receiveEmailDataSuccess = emailData => batchActions([receiveEmailData(emailData), loadingEmails(false)]);
const receiveEmailDataFail = () => batchActions([displayErrorMessage('There was an issue fetching your email data'), loadingEmails(false)]);

const downloadEmailDataFail = () => batchActions([displayErrorMessage('There was an issue downloading your email data'), downloadingEmails(false)]);
const downloadEmailDataSuccess = () => batchActions([sendMessage('Your Collected Emails have been downloaded!'), downloadingEmails(false)]);
const downloadEmailNoData = () => batchActions([displayErrorMessage('Sorry there is no data to download.'), downloadingEmails(false)]);
//thunks
export const getEmailData = (embedUUID, page, startDate, endDate) => dispatch => {
    dispatch(loadingEmails(true));
    getEmbedEmailData(embedUUID, page, startDate, endDate, false)
        .then(response => dispatch(receiveEmailDataSuccess(response.data)))
        .catch(err => dispatch(receiveEmailDataFail()))

};

export const downloadEmailData = (embedUUID, page, startDate, endDate) => dispatch => {
    dispatch(downloadingEmails(true));
    getEmbedEmailData(embedUUID, page, startDate, endDate, true)
        .then(response => {
            if(response.data.userData && response.data.userData.length){
                exportcsv(formatEmailsData(response.data.userData), `Emails_Collected.csv`);
                return dispatch(downloadEmailDataSuccess())
            }
            return dispatch(downloadEmailNoData())
        })
        .catch(err => console.log(err) || dispatch(downloadEmailDataFail()))
};

const formatEmailsData = data => {
    let formattedData = ``;
    formattedData = Object.keys(data[0]).join(',');
    data.forEach(row => formattedData = `${formattedData}\n${row.date}, ${row.email}, ${row.city}, ${row.country}`);
    return formattedData;
};